import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';

export const SmsCollection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};

  [data-expand-more] {
    margin-top: 0;
  }
`;
